import type { Animal } from "@/lib/types";

export function AnimalInfoCard({ animal }: { animal: Animal }) {
  // Format birth date
  const birthDate = new Date(animal.birthDate).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <div className="grid grid-cols-2 gap-4">
      <div className="space-y-4">
        <div>
          <h3 className="text-sm font-medium text-muted-foreground">
            Basic Information
          </h3>
          <div className="grid grid-cols-2 gap-2 mt-2">
            <div className="text-sm font-medium">Name:</div>
            <div className="text-sm">{animal.name}</div>
            <div className="text-sm font-medium">Sex:</div>
            <div className="text-sm">{animal.sex}</div>
            <div className="text-sm font-medium">Birth Date:</div>
            <div className="text-sm">{birthDate}</div>
            <div className="text-sm font-medium">DGR:</div>
            <div className="text-sm">{animal.dgr}</div>
            <div className="text-sm font-medium">Status:</div>
            <div className="text-sm capitalize">{animal.animalStatus}</div>
          </div>
        </div>

        <div>
          <h3 className="text-sm font-medium text-muted-foreground">
            Farm Information
          </h3>
          <div className="grid grid-cols-2 gap-2 mt-2">
            <div className="text-sm font-medium">Farm:</div>
            <div className="text-sm capitalize">{animal?.farm}</div>
            <div className="text-sm font-medium">Supervisor:</div>
            <div className="text-sm capitalize">
              {animal?.assignedSupervisor}
            </div>
            <div className="text-sm font-medium">Class:</div>
            <div className="text-sm capitalize">{animal.cattleClass}</div>
            <div className="text-sm font-medium">Phase:</div>
            <div className="text-sm">{animal.phases}</div>
          </div>
        </div>
      </div>

      <div className="space-y-4">
        <div>
          <h3 className="text-sm font-medium text-muted-foreground">
            Physical Attributes
          </h3>
          <div className="grid grid-cols-2 gap-2 mt-2">
            <div className="text-sm font-medium">Weight:</div>
            <div className="text-sm">{animal.weight} kg</div>
            <div className="text-sm font-medium">Birth Weight:</div>
            <div className="text-sm">{animal.birthWeight} kg</div>
            <div className="text-sm font-medium">ADG:</div>
            <div className="text-sm">{animal.adg} g/day</div>
            <div className="text-sm font-medium">Coat Color:</div>
            <div className="text-sm">{animal.coatColor}</div>
            <div className="text-sm font-medium">Size:</div>
            <div className="text-sm">{animal.size}</div>
          </div>
        </div>

        <div>
          <h3 className="text-sm font-medium text-muted-foreground">
            Performance
          </h3>
          <div className="grid grid-cols-2 gap-2 mt-2">
            <div className="text-sm font-medium">Efficiency Index:</div>
            <div className="text-sm">{animal.indexEfficiency}</div>
            <div className="text-sm font-medium">Evaluation:</div>
            <div className="text-sm">{animal.evaluation}</div>
            <div className="text-sm font-medium">Offspring:</div>
            <div className="text-sm">{animal.numberOffspring}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
